export const formatShortLocale = (locale) => {
    try {
        const [lang, country] = locale.split("-");
        return `${lang}_${country.toUpperCase()}`;
    }
    catch (e) {
        const message = e instanceof Error ? e.message : String(e);
        console.error(message);
        return "en_US";
    }
};
//# sourceMappingURL=formatLocale.js.map